module.exports = __webpack_public_path__ + "img/1556321116.186ade44.jpg";